import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { clientsRepo } from '../repo/clientsRepo'
import { logAudit } from '@/lib/audit'

export function useClients() {
  return useQuery({
    queryKey: ['clients'],
    queryFn: () => clientsRepo.findAll(),
  })
}

export function useClient(id: string | undefined) {
  return useQuery({
    queryKey: ['clients', id],
    queryFn: () => id ? clientsRepo.findById(id) : null,
    enabled: !!id,
  })
}

export function useCreateClient() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (client: any) => clientsRepo.create(client),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
      logAudit({
        action: 'create_client',
        resource_type: 'client',
        resource_id: data.id,
        client_id: data.id,
      })
    },
  })
}

export function useUpdateClient() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: any }) =>
      clientsRepo.update(id, updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
      queryClient.invalidateQueries({ queryKey: ['clients', data.id] })
      logAudit({
        action: 'update_client',
        resource_type: 'client',
        resource_id: data.id,
        client_id: data.id,
      })
    },
  })
}

export function useDeleteClient() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => clientsRepo.delete(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['clients'] })
      queryClient.invalidateQueries({ queryKey: ['clients', id] })
      queryClient.invalidateQueries({ queryKey: ['customers'] })
      queryClient.invalidateQueries({ queryKey: ['invoices'] })
      queryClient.invalidateQueries({ queryKey: ['dashboard'] })
      logAudit({
        action: 'delete_client',
        resource_type: 'client',
        resource_id: id,
      })
    },
    onError: (error) => {
      console.error('useDeleteClient mutation error:', error)
    },
  })
}
